function overflowYAllowsScroll(node) {
    if (!node || node === document.body || node === document.documentElement) return false;
    const overflowY = window.getComputedStyle(node).overflowY;
    return overflowY === 'auto' || overflowY === 'scroll' || overflowY === 'overlay';
}

function isVerticallyScrollable(node) {
    return overflowYAllowsScroll(node) && node.scrollHeight > node.clientHeight + 1;
}

export function getOverflowScrollParent(el) {
    if (!el || typeof el.closest !== 'function') return null;
    let node = el.parentElement;
    while (node && node !== document.documentElement) {
        if (isVerticallyScrollable(node)) return node;
        node = node.parentElement;
    }
    const known = el.closest('.deal-form-left-column, .deal-form-body');
    if (known && overflowYAllowsScroll(known)) return known;
    const body = el.closest('.deal-form-body');
    if (body && overflowYAllowsScroll(body)) return body;
    return null;
}

export function scrollIntoContainer(el, { offset = 16, block = 'nearest' } = {}) {
    if (!el) return null;
    const root = getOverflowScrollParent(el);
    if (!root) return null;
    const rootRect = root.getBoundingClientRect();
    const elRect = el.getBoundingClientRect();
    let delta = 0;
    if (block === 'center') {
        delta = elRect.top - rootRect.top - rootRect.height / 2 + elRect.height / 2;
    } else if (block === 'start') {
        delta = elRect.top - rootRect.top - offset;
    } else if (elRect.top < rootRect.top + offset) {
        delta = elRect.top - rootRect.top - offset;
    } else if (elRect.bottom > rootRect.bottom - offset) {
        delta = elRect.bottom - rootRect.bottom + offset;
    }
    if (delta) root.scrollTop += delta;
    return root;
}
